import React, { useEffect } from "react";
import { supabase } from "../supabaseClient";
import { useNavigate } from "react-router-dom";

export default function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    const performLogout = async () => {
      try {
        // 1. Attempt Supabase Sign Out
        const { error } = await supabase.auth.signOut();
        if (error) console.error("Supabase logout error:", error.message);
      } catch (err) {
        console.error("Unexpected logout error:", err);
      } finally {
        // 2. Nuke Local Storage (Manual Cleanup)
        // This ensures no tokens remain in the browser storage
        Object.keys(localStorage).forEach((key) => {
          if (key.includes("supabase")) localStorage.removeItem(key);
        });
        
        sessionStorage.clear();
        
        console.log("✅ Logged out successfully");

        // 3. Navigate with State
        // We pass { loggedOut: true } so the Login page knows not to auto-redirect
        navigate("/login", { 
            replace: true, 
            state: { loggedOut: true } 
        });
      }
    };

    performLogout();
  }, [navigate]);

  return (
    <div className="flex justify-center items-center h-screen bg-black text-white">
      <div className="flex flex-col items-center gap-4">
        <div className="animate-spin h-8 w-8 border-4 border-blue-500 border-t-transparent rounded-full"></div>
        <p className="text-gray-400 text-sm tracking-widest uppercase">Logging out...</p>
      </div>
    </div>
  );
}